import { useEffect, useState } from "react";
import { iAxios } from "../../lib/utils";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import { alertMessage } from "../../lib/actions";
import { StatusLabel } from "../common/Helper";
import Icon from "../ds/Icon";

const TeamActivity = (props) => {
    const dispatch = useDispatch();
    const [data, setData] = useState([]);
    const [timer, setTimer] = useState(Date.now());
    const [deletingUrl, setDeletingUrl] = useState(null);
    const [armedUrl, setArmedUrl] = useState(null);
    // Tracks URLs successfully deleted this session so they are filtered out of polls
    // until the server's screenList is overwritten by the next heartbeat
    const [deletedUrls, setDeletedUrls] = useState(new Set());
    const userFilter = useSelector(st => st.tickets.userFilter);
    const userInfo = useSelector(st => st.userInfo);

    const handleDeleteScreenshot = async (screen, username) => {
        setArmedUrl(null);
        setDeletingUrl(screen.url);
        try {
            const resp = await iAxios.delete('/api/v1/admin/screenshot', { data: { imageUrl: screen.url } });
            if (resp.data.success) {
                setDeletedUrls(prev => new Set([...prev, screen.url]));
                setData(prev => prev.map(member =>
                    member.username !== username ? member : {
                        ...member,
                        screens: member.screens.filter(s => s.url !== screen.url)
                    }
                ));
            } else {
                dispatch(alertMessage(resp.data.message || 'Failed to delete screenshot', 'Error'));
            }
        } catch (err) {
            console.error('Delete screenshot failed', err);
            dispatch(alertMessage('Failed to delete screenshot', 'Error'));
        } finally {
            setDeletingUrl(null);
        }
    };

    useEffect(() => {
        iAxios.get('/api/v1/team-activity').then(resp => {
            const list = resp.data.data;
            setArmedUrl(null); // disarm any pending confirmation when data refreshes
            setData(list
                .filter(t => userFilter.some(u => u.username === t.username))
                .map(member => ({
                    ...member,
                    // filter out URLs deleted this session that haven't yet cleared from the server
                    screens: member.screens?.filter(s => !deletedUrls.has(s.url))
                }))
            );
        });
    }, [timer, userFilter])

    useEffect(() => {
        const timerId = setInterval(() => {
            setTimer(Date.now());
        }, 5e4)
        return () => {
            clearInterval(timerId);
        }
    }, [1]);
    return <div className="ds-scope"><div className="activity-grid">
        {data.map((item) => {
            return <div key={item.name} className="activity-card">
                <div className="activity-card__shots">
                    {item.statusGroup !== 'In' && <div className="activity-status">
                        <StatusLabel info={item} />
                    </div>}

                    {(!item.screens || item?.screens.length === 0) && (
                        <div className="activity-stale">Not updated</div>
                    )}

                    {item?.screens?.map((screen, idx) => {
                        if (screen.tm < Date.now() - 36e5) {
                            return <div key={`${idx}-${screen.tm}`} className="activity-stale">
                                Last updated {moment(screen.tm).fromNow()}
                            </div>;
                        }
                        return <div key={`screen-${idx}`} className="activity-shot">
                            <img onError={(e) => e.target.src = '/missing.png'} src={screen.url} alt="screenshot" />
                            <span className="activity-shot__time">{moment(screen.tm).fromNow()}</span>
                            {userInfo?.role === 'Admin' && (
                                armedUrl === screen.url ? (
                                    <div className="activity-del" style={{ opacity: 1 }}>
                                        <button className="activity-del__btn is-confirm"
                                            onClick={() => handleDeleteScreenshot(screen, item.username)}
                                            title="Confirm delete" aria-label="Confirm delete">
                                            <Icon name="check" />
                                        </button>
                                        <button className="activity-del__btn"
                                            onClick={() => setArmedUrl(null)}
                                            title="Cancel" aria-label="Cancel delete">
                                            <Icon name="close" />
                                        </button>
                                    </div>
                                ) : (
                                    <div className="activity-del">
                                        <button className="activity-del__btn is-danger"
                                            onClick={() => setArmedUrl(screen.url)}
                                            disabled={deletingUrl === screen.url}
                                            title="Delete screenshot" aria-label="Delete screenshot">
                                            {deletingUrl === screen.url ? '…' : <Icon name="trash" />}
                                        </button>
                                    </div>
                                )
                            )}
                        </div>;
                    })}
                </div>
                <div className="activity-card__foot">
                    <a href={`/my-day/${item.username}`} target="_blank" rel="noreferrer">{item.name}</a>
                </div>
            </div>;
        })}
    </div></div>;
}

export default TeamActivity;